import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { AvatarMenu } from './AvatarMenu';
import { SyncStatus } from './SyncStatus';
import { Logo } from './Logo';
export function MobileHeader() {
  const {
    family
  } = useAppState();
  return <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-line bg-canvas/95 px-4 py-2.5 backdrop-blur md:hidden" data-id="element-897" data-mp="19cynp2i4ugx1">
      <div className="min-w-0 flex-1" data-id="element-898" data-mp="216scrqgp8i4u">
        <Logo compact data-id="element-899" data-mp="215pnfmz0ynr1" />
        <p className="mt-1 truncate text-xs font-bold text-muted" data-id="element-900" data-mp="214657qtt62mm">Družina {family.name}</p>
      </div>
      <SyncStatus data-id="element-901" data-mp="1x32n0xoafui8" />
      <AvatarMenu placement="down" data-id="element-902" data-mp="1s5azsgyl8wkd" />
    </header>;
}